import { Link } from "@mui/material";
import { CopyrightButton } from "../CopyrightButton/CopyrightButton";
import { myWhite } from "../../constants/colors";
import { useVrsTranslationState } from "../../context/AppContext/AppContext";
import { styled } from "@mui/material/styles";

const RootContainer = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  textAlign: "center",
  margin: theme.spacing(0, -1),
  padding: theme.spacing(0, 1.5),
  backgroundColor: myWhite,
  [theme.breakpoints.down("sm")]: {
    margin: theme.spacing(0, -1.125),
    padding: theme.spacing(0),
  }
}));

const FooterLinkContainer = styled("div")(({ theme }) => ({
  display: "flex",
  padding: theme.spacing(1.125, 2.5),
  [theme.breakpoints.down("xs")]: {
    padding: theme.spacing(0.625, 0.125),
  }
}));

const FooterLink = styled("div")(({ theme }) => ({
  marginRight: theme.spacing(2),
}));


const Footer = () => {
  const { _T } = useVrsTranslationState();

  return (
    <RootContainer>
      <FooterLinkContainer>
        <FooterLink>
          <Link
            component="a"
            variant="body2"
            target="_blank"
            href="https://www.videojet.com"
          >
            <CopyrightButton />
          </Link>
        </FooterLink>

        <FooterLink>
          <Link
            component="a"
            variant="body2"
            target="_blank"
            href="https://www.videojet.com/us/homepage/general/privacy-policy.html"
          >
            {_T("PrivacyPolicy")}
          </Link>
        </FooterLink>
        <FooterLink>
          <Link
            component="a"
            variant="body2"
            target="_blank"
            href="https://www.videojet.com/content/dam/pdf/NA%20-%20English/privacy-policy/Videojet-online-terms-of-use-us.pdf"
          >
            {_T("TermsofUse")}
          </Link>
        </FooterLink>
      </FooterLinkContainer>
    </RootContainer>
  );
};

export { Footer };
